import * as actions from './ExitPoll.actions';

export const initialState = {
    enabled: false,
    value: null,
    loading: false,
    saved: false
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actions.SHOW_EXIT_POLL:
            return {
                ...state,
                enabled: true
            };
        case actions.HIDE_EXIT_POLL:
            return {
                ...state,
                enabled: false
            };
        case actions.EXIT_POLL_ANSWER:
            return {
                ...state,
                value: action.value,
                loading: true
            };
        case actions.EXIT_POLL_ANSWER_SAVE_SUCCEED:
            return {
                ...state,
                loading: false,
                saved: true
            };
        default:
            return state;
    }
}
